import { render } from "./P043.vue?vue&type=template&id=263a3554&scoped=true"
import script from "./P043.vue?vue&type=script&lang=js"
export * from "./P043.vue?vue&type=script&lang=js"

import "./P043.vue?vue&type=style&index=0&id=263a3554&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263a3554"]])

export default __exports__